import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation PreviewBulkTaxProfileTemplate(
    $input: TaxProfileTemplateBulkPreviewInput!
  ) {
    previewTaxProfileTemplateBulk(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      preview {
        alreadySatisfiedProductIds
        blockedProductIds
        conflictedProductIds
        eligibleProductIds
        previewDigest
      }
    }
  }
  ${ErrorMessageInfo}
`;
